import { Injectable } from '@angular/core'

@Injectable()
export class Globals {
  public isLogin: boolean = false;
  public iban: any;
  public selectedCurrency: string = 'JOD';
  public transferType: string = '';
  public ownAccountTransferType: string = '';
  public selectedAccountNo: any;
  accountType: string = '';
  selectedCountry: any;
  selectedCountryFlag: any;
  transferOtpBody: any = {};
  isSavedbeneficary: boolean = false;
  loanCurrency: string = 'JOD';
  termDepositCurrency: string = 'JOD';
  currentPoints: any = '-- ';
  errorCount: number = 0;
  tranferAccountIban: any;
  countrySelection: boolean = false;
  transferPage: string = 'accounts';
  latitute: string = '30.162944';
  longitute: string = '77.2898816'
  weeklySpendingAmount: any = 0;
  deviceId: string = '';
  userEmail: any;
  isMigratedFlow: boolean = false;
  username: any;
  userDetails: any;
  isVipUser: boolean = false;
  deviceIp: string = ''
  transferAccountType: any;
  benId: any;
  selectedCountryISOCode: any;
  selectedView:string = 'personal';
  allowForgetPinFlow:boolean = false;
  allowChangePin:boolean = false;


  updateTheme(userDetails: any) {
    this.isVipUser = userDetails.isVipCustomer;
    if (this.isVipUser) {
      let palatte = [
        { name: '--primary-color', value: '#B18D53' },
        { name: '--primary-color-to-white', value: '#FFFFFF' },
        { name: '--primary-color1', value: '#1A160F' },
        { name: '--primary-color2', value: '#B18D53' },
        { name: '--primary-color-bg2', value: '#FFFFFF' },
        { name: '--border-color1', value: '#D3D3D3' },
        { name: '--border-color2', value: '#B5B5B5' },
        { name: '--secondary-color-text', value: '#B18D53' },
        { name: '--secondary-color-bg', value: '#4D9BDA' },
        { name: '--secondary-color-to-white', value: '#FFFFFF' },
        { name: '--box-bg-color', value: '#514F4F' },
        { name: '--sub-text-color', value: '#9D9D9D' },
        { name: '--error-color1', value: '#BDBDBD' },
        { name: '--text-color1', value: '#FFFFFF' },
        { name: '--text-color2', value: '#9F9F9F' },
        { name: '--text-color3', value: '#FFFFFF' },
        { name: '--text-color4', value: '#FFFFFF' },
        { name: '--text-color5', value: '#FFFFFF' },
        { name: '--text-color6', value: '#FFFFFF' },
        { name: '--placeholder-color', value: '#9F9F9F' }
      ]

      palatte.forEach(ele => {
        document.documentElement.style.setProperty(ele.name, ele.value);
      })

      let parentContainer = document.getElementsByTagName('body')[0];
      if (parentContainer) {
        parentContainer.classList.add('dark-parent-container');
      }
    }
    else {
      let palatte = [
        { name: '--primary-color', value: '#283742' },
        { name: '--primary-color-to-white', value: '#283742' },
        { name: '--primary-color1', value: '#26323f' },
        { name: '--primary-color2', value: '#26333f' },
        { name: '--primary-color-bg2', value: '#26333f' },
        { name: '--border-color1', value: '#D3D3D3' },
        { name: '--border-color2', value: '#B5B5B5' },
        { name: '--secondary-color-text', value: '#4D9BDA' },
        { name: '--secondary-color-bg', value: '#4D9BDA' },
        { name: '--secondary-color-to-white', value: '#4D9BDA' },
        { name: '--box-bg-color', value: '#FFFFFF' },
        { name: '--sub-text-color', value: '#898989' },
        { name: '--error-color1', value: '#404040' },
        { name: '--text-color1', value: '#2D3748' },
        { name: '--text-color2', value: '#718096' },
        { name: '--text-color3', value: '#000000' },
        { name: '--text-color4', value: '#272331' },
        { name: '--text-color5', value: '#5E5E5E' },
        { name: '--text-color6', value: '#2f363b' },
        { name: '--placeholder-color', value: '#B5B5B5' }
      ]

      palatte.forEach(ele => {
        document.documentElement.style.setProperty(ele.name, ele.value);
      })

      let parentContainer = document.getElementsByTagName('body')[0];
      if (parentContainer && parentContainer.classList.contains('dark-parent-container')) {
        parentContainer.classList.remove('dark-parent-container');
      }
    }
  }
}